import { List, NeoModel } from "@singularsystems/neo-core";
import { Views } from "@singularsystems/neo-react";
import { AppService, Types } from "../../../App/Services/AppService";
import RawGenericExportMappingLookup from "../Models/Lookups/RawGenericExportMappingLookup";
import StaticExportColumnSpecLookup from "../../ExportColumnSpecs/Models/Lookups/StaticExportColumnSpecLookup";

@NeoModel
export default class ManageRawGenericExportMappingComponentVM extends Views.ViewModelBase {
    constructor(
        taskRunner = AppService.get(Types.Neo.TaskRunner),
        public generalApiClient = AppService.get(Types.ApiClients.GeneralApiClient),
        public rawGenericExportMappingApiClient = AppService.get(Types.ApiClients.RawGenericExportMappingApiClient),
        public fileGroupingFileSpecApiClient = AppService.get(Types.ApiClients.FileGroupingExportFileSpecApiClient),
        public staticExportColumnSpecApiClient = AppService.get(Types.ApiClients.StaticExportColumnSpecApiClient)
    ) 
        {
            super(taskRunner);
        }   

    public managedGenericMapping = new RawGenericExportMappingLookup();
    public fileSpecList = new List(StaticExportColumnSpecLookup);
    public isFieldReadOnlyInd: boolean = false;
    public staticExportFileSpecId: number = 0;

    public async initialise() {
    }
}